import { jsx, jsxs } from "react/jsx-runtime";
import {
  Card,
  CardContent,
  CardHeader,
  ListItem,
  Skeleton,
  Typography,
  cardContentClasses,
  cardHeaderClasses
} from "@mui/material";
const avatar = `.${cardHeaderClasses.avatar}`;
const content = `.${cardContentClasses.root}`;
const cardOverrides = (theme) => ({
  border: `1px solid ${theme.vars.palette.grey[300]}`,
  width: "100%",
  [content]: {
    paddingTop: 0
  },
  [`${content}:last-child`]: {
    paddingBottom: theme.spacing(1.5)
  }
});
const headerOverrides = (theme) => ({
  paddingBottom: 0,
  paddingTop: theme.spacing(1.5),
  [avatar]: {
    marginRight: theme.spacing(1)
  }
});
function AppLauncherCardSkeleton(props) {
  const { testId } = props;
  return /* @__PURE__ */ jsx(ListItem, { "data-tidal": "TidalAppLauncherSkeletonCard", "data-testid": testId, sx: { paddingY: 0.5 }, children: /* @__PURE__ */ jsxs(Card, { elevation: 0, sx: cardOverrides, "data-testid": "appLauncherSkeletonCard", children: [
    /* @__PURE__ */ jsx(
      CardHeader,
      {
        sx: headerOverrides,
        avatar: /* @__PURE__ */ jsx(Skeleton, { width: 32, height: 32, variant: "circular" }),
        title: /* @__PURE__ */ jsx(Typography, { variant: "h4", children: /* @__PURE__ */ jsx(Skeleton, {}) })
      }
    ),
    /* @__PURE__ */ jsx(CardContent, { children: /* @__PURE__ */ jsx(Typography, { variant: "h5", children: /* @__PURE__ */ jsx(Skeleton, {}) }) })
  ] }) });
}
export {
  AppLauncherCardSkeleton
};
//# sourceMappingURL=AppLauncherCardSkeleton.js.map
